module.exports = __webpack_public_path__ + "img/自考毕业证书.55833682.jpg";